// Repeated moves in a routine score zero difficulty. A move repeats an earlier
// one if it is the same library skill, or has the same name (ignoring case and
// surrounding spaces), so a typed-in "barani" after a library "Barani" counts.
// Mirrors the backend's services/routineSkillShape.js.

const nameKey = (name) => `name:${(name || '').trim().toLowerCase()}`;

// Returns copies of the skills with `isRepeat` set on second and later copies.
export function markRepeats(skills) {
  const seen = new Set();
  return skills.map(skill => {
    const keys = [nameKey(skill.name)];
    if (!skill.isImplicit && skill.skillId) keys.push(`id:${skill.skillId}`);
    const isRepeat = keys.some(k => seen.has(k));
    keys.forEach(k => seen.add(k));
    return { ...skill, isRepeat };
  });
}

// A skill's difficulty on an apparatus: double mini has its own values
// (dmtDifficulty). Mirrors the backend's difficultyFor.
export function difficultyFor(skill, apparatus) {
  const dd = apparatus === 'DMT' ? skill.dmtDifficulty : skill.difficulty;
  return dd == null || dd === '' ? null : Number(dd);
}

// Total difficulty, with repeats scoring zero. Decimals may arrive as strings,
// hence Number().
export function totalDifficulty(skills, apparatus = 'TRA') {
  const total = markRepeats(skills).reduce((sum, skill) => {
    const dd = difficultyFor(skill, apparatus);
    if (skill.isRepeat || dd == null) return sum;
    return sum + dd;
  }, 0);
  return Math.round(total * 10) / 10;
}
